import { batch } from 'react-redux';
import type { AppDispatch } from '@client/store';
import type { AnyAction } from '@reduxjs/toolkit';

/**
 * Utility class for grouping and dispatching actions of the same type at the same time
 * See Pool for usage
 */
export class Action {
  timeout = null;

  defaultTimer = 25;

  actions: AnyAction[] = [];

  dispatch: AppDispatch;

  constructor(action: AnyAction, dispatch: AppDispatch) {
    this.dispatch = dispatch;
    this.add(action);
  }

  add = (action: AnyAction) => {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => this.flush(), this.defaultTimer);
    this.actions = [
      ...this.actions,
      action,
    ];
  };

  flush = () => {
    batch(() => {
      this.actions.forEach((action) => {
        this.dispatch(action);
      });
    });

    this.actions = [];
    this.timeout = null;
  };
}
